import React, {Component} from 'react';
import './Footer.css';
import logo from '../../images/pplogo-64.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';


export default class Footer extends Component {

	render() {
		return (
			<div className="footer_container" id="Footer">
				<div className="footer_contact_title">CONTACT US</div>
				<div className="footer_contact_content">
					<div className="footer_contact_content_child">
						<FontAwesomeIcon icon={faEnvelope} size="2x"/>
						<span>enquiry@pacificprince.com.sg</span>
					</div>
					<div className="footer_contact_content_child">
						<FontAwesomeIcon icon={faPhone} size="2x"/>
						<span>+65 6324 6880</span>
					</div>
				</div>

				<div className="footer_content">
					<img src={logo} />
					<div className="footer_content_title">PACIFIC PRINCE INTERNATIONAL PTE LTD</div>
					<div className="footer_content_subtitle">10 UBI CRESCENT #04-25, SINGAPORE 408564</div>
				</div>

			</div>
		)
	}
};
